import React from 'react'
import { Box, Color, Display, FlexDirection, Body1 } from '@gousto-internal/citrus-react'

import type { LoggedOutBoxSummaryActions, LoggedOutBoxSummaryDeliveryView } from '../types'

type DeliveryPanelProps = {
  view: LoggedOutBoxSummaryDeliveryView
  actions: Pick<
    LoggedOutBoxSummaryActions,
    | 'onDeliveryPostcodeEdit'
    | 'onDeliveryDateSelect'
    | 'onDeliverySlotSelect'
    | 'onDeliveryInstructionChange'
    | 'onDeliveryInstructionCustomChange'
    | 'onDeliveryContinue'
  >
}

// Scaffold: `actions` is a forward-declared contract the modal already wires up;
// it is intentionally not consumed yet and will be when this panel is built out.
export const DeliveryPanel = ({ view }: DeliveryPanelProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    paddingH={3}
    paddingBottom={6}
    data-testid="logged-out-box-summary-delivery-panel"
  >
    <Body1 color={Color.ColdGrey_800}>{view.title}</Body1>
  </Box>
)
